import Link from 'next/link';
import React from 'react';

import styles from './SeeAllLink.module.scss';

interface ISeeAllLinkProps {
  link: string;
  text: string;
  arrow?: boolean;
}

const SeeAllLink = ({ link, text, arrow = false }: ISeeAllLinkProps) => {
  return (
    <Link href={link} className={ styles.Root}>
      { /* eslint-disable-next-line jsx-a11y/anchor-is-valid */}
      <a className={styles.Root}>
        {text} { arrow && <>&gt;</>}
      </a>
    </Link>
  );
};

export default SeeAllLink;
